import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UnitCustomInput, UnitCustomUnits } from '@core/models/unit-custom.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnitService {
  private baseUrl: string = environment.apiUrl + '/unit';

  constructor(private http: HttpClient) {}

  public getCustomUnit(user: string): Observable<Array<UnitCustomUnits>> {
    return this.http.get<Array<UnitCustomUnits>>(this.baseUrl + '/get-custom/' + user);
  }

  public setCustomUnit(input: UnitCustomInput): Observable<Array<UnitCustomUnits>> {
    return this.http.post<Array<UnitCustomUnits>>(this.baseUrl + '/set-custom', input);
  }
}
